import React, { ReactNode, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SearchOutlined } from '@ant-design/icons';
import { Button, DatePicker, Input, Radio, Select, Space, message } from 'antd';
import { BaseOptionType } from 'antd/es/select';
import dayjs, { Dayjs } from 'dayjs';

import Configurazione from '../Configurazione';
import { GetErrorMessage } from '../Utility';
import api from '../api';
import stringres from '../translations/stringres';

export type filtriFields = {
    numeroBlocco: string | undefined;
    numeroBloccoFornitore: string | undefined;
    idQualita: string[] | undefined;
    codFinitura: string[] | undefined;
    dataInizio: Date | undefined;
    dataFine: Date | undefined;
    numFattura: string | undefined;
    fatturate: string | undefined;
};

interface filtri {
    numeroBloccoVisible: boolean;
    numeroBloccoFornitoreVisible: boolean;
    qualitaVisible: boolean;
    finituraVisible: boolean;
    periodoVisible: boolean;
    fatturazioneVisible: boolean;
    dataIni: Dayjs | null;
    params: URLSearchParams | null;
    contoTerzi: boolean;
    onconfirm: (arg: filtriFields) => any;
}

export default function FiltriMagazzino({
    numeroBloccoVisible,
    numeroBloccoFornitoreVisible,
    qualitaVisible,
    finituraVisible,
    periodoVisible,
    fatturazioneVisible,
    params,
    contoTerzi,
    onconfirm,
}: filtri) {
    const [querystring, setQuerystring] = useSearchParams();
    const [elencoQualita, setElencoQualita] = useState<BaseOptionType[]>([]);

    const [elencoFiniture, setElencoFiniture] = useState<BaseOptionType[]>([]);

    const [numeroBlocco, setNumeroBlocco] = useState<string | undefined>(params?.get('nb')?.toString());
    const [numeroBloccoFornitore, setNumeroBloccoFornitore] = useState<string | undefined>(
        params?.get('nbf')?.toString()
    );
    const [idQualitaSelezionate, setIdQualitaSelezionate] = useState<string[] | undefined>(params?.getAll('iq'));
    const [codFinituraSelezionate, setCodFinituraSelezionate] = useState<string[] | undefined>(params?.getAll('cf'));
    const [dataInizio, setdataInizio] = useState<Dayjs | null>(
        params?.get('di') === undefined ? dayjs().subtract(2, 'months') : dayjs(params?.get('di')?.toString())
    );
    const [dataFine, setdataFine] = useState<Dayjs | null>(dayjs(params?.get('df')?.toString()));
    const [numFattura, setNumFattura] = useState(params?.get('nf')?.toString());
    const [fatturate, setFatturate] = useState(params?.get('f')?.toString());

    useEffect(() => {
        fetch();
    }, []);

    async function fetch() {
        try {
            const resqual = await api.get('Tabelle/QualitaWeb?idSocieta=' + Configurazione().idsocieta);

            const opt: any = [];
            resqual.data.forEach((element: any) => {
                opt.push({
                    label: element.descrizioneQualita,
                    value: String(element.idQualita),
                });
            });

            setElencoQualita(opt);

            const resfin = await api.get('Tabelle/FinitureWeb?idSocieta=' + Configurazione().idsocieta);

            const optFin: any = [];
            resfin.data.forEach((element: any) => {
                optFin.push({
                    value: element.codiceFinitura,
                    label: element.descrizioneFinitura,
                });

                setElencoFiniture(optFin);
            });
        } catch (error) {
            message.error(GetErrorMessage(error));
        }
    }

    function onclick() {
        const f: filtriFields = {
            numeroBlocco: numeroBlocco,
            numeroBloccoFornitore: numeroBloccoFornitore,
            idQualita: idQualitaSelezionate,
            codFinitura: codFinituraSelezionate,
            dataInizio: dataInizio?.toDate(),
            dataFine: dataFine?.toDate(),
            numFattura: numFattura,
            fatturate: fatturate,
        };

        onconfirm(f);
    }

    function onKeyDown(e: any) {
        if (e.keyCode === 13) {
            onclick();
        }
    }

    return (
        <div>
            <Space wrap align="start">
                {numeroBloccoVisible ? (
                    <Input
                        size="large"
                        onKeyDown={onKeyDown}
                        value={numeroBlocco}
                        onChange={(e) => setNumeroBlocco(e.target.value)}
                        style={{ width: '125px' }}
                        placeholder={stringres.t('numeroBlocco')}
                    ></Input>
                ) : null}
                {numeroBloccoFornitoreVisible ? (
                    <Input
                        size="large"
                        onKeyDown={onKeyDown}
                        value={numeroBloccoFornitore}
                        onChange={(e) => setNumeroBloccoFornitore(e.target.value)}
                        style={{ width: '125px' }}
                        placeholder={
                            contoTerzi ? stringres.t('numeroBloccoCliente') : stringres.t('numeroBloccoFornitore')
                        }
                    ></Input>
                ) : null}
                {qualitaVisible ? (
                    <Select
                        size="large"
                        mode="multiple"
                        allowClear
                        showSearch
                        style={{ width: '250px' }}
                        placeholder={stringres.t('qualita').toString()}
                        onChange={(e) => setIdQualitaSelezionate(e)}
                        options={elencoQualita}
                        value={idQualitaSelezionate}
                        filterOption={(input, option) =>
                            option?.label?.toString().toUpperCase().includes(input.toUpperCase()) ? true : false
                        }
                    />
                ) : null}
                {finituraVisible ? (
                    <Select
                        size="large"
                        mode="multiple"
                        allowClear
                        style={{ width: '250px' }}
                        placeholder={stringres.t('finitura').toString()}
                        onChange={(e) => setCodFinituraSelezionate(e)}
                        options={elencoFiniture}
                        value={codFinituraSelezionate}
                        filterOption={(input, option) =>
                            option?.label?.toString().toUpperCase().includes(input.toUpperCase()) ? true : false
                        }
                    />
                ) : null}
                {periodoVisible ? (
                    <DatePicker
                        size="large"
                        value={dataInizio}
                        onChange={(e) => setdataInizio(e)}
                        placeholder="Data Inizio"
                    ></DatePicker>
                ) : null}
                {periodoVisible ? (
                    <DatePicker
                        size="large"
                        value={dataFine}
                        onChange={(e) => setdataFine(e)}
                        placeholder="Data Fine"
                    ></DatePicker>
                ) : null}
                {fatturazioneVisible ? (
                    <Input
                        size="large"
                        style={{ width: '125px' }}
                        placeholder={stringres.t('numeroFattura')}
                        hidden={fatturazioneVisible}
                        onChange={(e) => setNumFattura(e.target.value)}
                    ></Input>
                ) : null}

                {fatturazioneVisible ? (
                    <Radio.Group
                        options={[
                            { label: 'Tutte', value: 'T' },
                            { label: 'Fatt.', value: 'F' },
                            { label: 'Non Fatt.', value: 'NF' },
                        ]}
                        onChange={(e) => setFatturate(e.target.value)}
                        value={fatturate}
                    ></Radio.Group>
                ) : null}
                <Button onClick={onclick} icon={<SearchOutlined />}>
                    {stringres.t('conferma') as ReactNode}
                </Button>
            </Space>
        </div>
    );
}
